/**
 * 类型判断
 */

 /**
  * 判断是否是函数
  * @param obj 需要判断的对象
  */
export const isFunction = (obj: any) => {
    try {
        if(!!obj && typeof obj === 'function') {
            return true
        }
        return false
    }catch(err) {
        return false
    }
}


/**
 * 判断是否为数组
 * @param obj 需要判断的对象
 */
export const isArray = (obj: any) => {
    try {
        return Array.isArray(obj)
    }catch(err) {
        return false
    }   
}

/**
 * 判断是否为对象
 */
export const isObject = (obj: any) => {
    return Object.prototype.toString.call(obj) === '[object Object]'
}

/**
 * 判断是否为字符串
 */
export const isString = (obj: any) => {
    return typeof(obj) === 'string'
}